import script from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./ThemeSwitch.vue?vue&type=style&index=0&id=3d9597bc&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9597bc"]])

export default __exports__